export interface MasonryOptions{
    itemSelector?: string;
    columnWidth?: number | string;
    gutter?: number | string;
    percentPosition?: boolean;
    stamp?: string;
    fitWidth?: boolean;
    originLeft?: boolean;
    originTop?: boolean;
    containerStyle?: any;
    transitionDuration?: string;
    resize?: boolean;
    initLayout?: boolean;
    horizontalOrder?: boolean;
}